<div class="cd-round-radio-button">
  @for (item of options; track item) {
  <div (click)="onChange(item.value)" class="item" [ngClass]="{ selected: selectedValue === item.value }">
    <span class="cds-detail2-demibold">{{ item.label }}</span>
  </div>
  }
</div>
